// extracted by mini-css-extract-plugin
module.exports = {"container":"accordion-view_container__0hlGd","open":"accordion-view_open__gXQlt","hidden":"accordion-view_hidden___TxjF"};